<template>
  <div v-if="visible" class="modal-mask modal-transition">
    <div class="modal-container caps-modal">
      <h1 class="modal-title">Caps</h1>

      <!-- Enable/Disable -->
      <div class="cap-section">
        <b-form-checkbox
          size="lg"
          type="checkbox"
          class="condition__matches campaign offerCapCheckbox"
          :checked="!!(offerCap.enabled)"
          @change="updateCap($event, `enabled`)"
        >
          Enable / Disable
        </b-form-checkbox>
        <span class="status-label">{{ offerCap.enabled ? "Enabled" : "Disabled" }}</span>
      </div>

      <!-- Conversions Cap -->
      <div class="cap-section">
        <h3 class="section-title">Conversions Cap</h3>
        <div class="cap-row">
          <div class="cap-control">
            <label>Amount (Day)</label>
            <input
              type="number"
              step="1"
              placeholder="1000"
              min="1"
              max="99999"
              :readonly="!!!(offerCap.enabled)"
              :value="offerCap.salesDay || 0"
              @change="updateCap($event, `salesDay`)"
              class="capInput"
              :class="disabledEnabledInput(!!(offerCap.enabled))"
              pattern="^\d+(?:\.\d{1,2})?$"
              onblur="this.parentNode.parentNode.style.backgroundColor=/^\d+(?:\.\d{1,2})?$/.test(this.value)?'inherit':'transparent'"
            />
          </div>
          <div class="cap-control">
            <label>Amount (Week)</label>
            <input
              type="number"
              step="1"
              placeholder="1000"
              min="1"
              max="99999"
              :value="offerCap.salesWeek || 0"
              :readonly="!!!(offerCap.enabled)"
              @change="updateCap($event, `salesWeek`)"
              class="capInput"
              :class="disabledEnabledInput(!!(offerCap.enabled))"
              pattern="^\d+(?:\.\d{1,2})?$"
              onblur="this.parentNode.parentNode.style.backgroundColor=/^\d+(?:\.\d{1,2})?$/.test(this.value)?'inherit':'transparent'"
            />
          </div>
          <div class="cap-control">
            <label>Amount (Month)</label>
            <input
              type="number"
              step="1"
              placeholder="1000"
              min="1"
              max="99999"
              :value="offerCap.salesMonth || 0"
              :readonly="!!!(offerCap.enabled)"
              @change="updateCap($event, `salesMonth`)"
              class="capInput"
              :class="disabledEnabledInput(!!(offerCap.enabled))"
              pattern="^\d+(?:\.\d{1,2})?$"
              onblur="this.parentNode.parentNode.style.backgroundColor=/^\d+(?:\.\d{1,2})?$/.test(this.value)?'inherit':'transparent'"
            />
          </div>
        </div>

        <!-- Redirect for Conversions -->
        <div class="redirect-section">
          <b-form-checkbox
            size="lg"
            type="checkbox"
            class="condition__matches campaign offerCapCheckbox"
            :checked="!!(offerCap.salesRedirectOfferUseDefault === null ? 1 : offerCap.salesRedirectOfferUseDefault)"
            @change="updateCap($event, `salesRedirectOfferUseDefault`)"
            :disabled="!!!(offerCap.enabled)"
          >
            Use exit traffic redirect when capped
          </b-form-checkbox>
          <custom-select
            v-show="!!!(offerCap.salesRedirectOfferUseDefault === null ? 1 : offerCap.salesRedirectOfferUseDefault)"
            :options="getOffersList()"
            label="nameId"
            @search="exitTrafficOffersUpd"
            :filterable="false"
            :value="offerCap.salesRedirectOfferId && offerCap.saleExitTrafficOfferName ? offerCap.salesRedirectOfferId + ' ' + offerCap.saleExitTrafficOfferName : ''"
            class="custom_select"
            @input="updateCap($event, `salesRedirectOfferId`)"
            :clearable="false"
            :id="defineId(`offerCapSales`, this.$route.params.id)"
          />
        </div>
      </div>

      <!-- Clicks Cap -->
      <div class="cap-section">
        <h3 class="section-title">Clicks Cap</h3>
        <div class="cap-row">
          <div class="cap-control">
            <label>Amount (Day)</label>
            <input
              type="number"
              step="1"
              placeholder="1000"
              min="1"
              max="99999"
              :value="offerCap && offerCap.clickDay || 0"
              :readonly="!!!(offerCap.enabled)"
              @change="updateCap($event, `clickDay`)"
              class="capInput"
              :class="disabledEnabledInput(!!(offerCap.enabled))"
              pattern="^\d+(?:\.\d{1,2})?$"
              onblur="this.parentNode.parentNode.style.backgroundColor=/^\d+(?:\.\d{1,2})?$/.test(this.value)?'inherit':'transparent'"
            />
          </div>
          <div class="cap-control">
            <label>Amount (Week)</label>
            <input
              type="number"
              step="1"
              placeholder="1000"
              min="1"
              max="99999"
              :value="offerCap && offerCap.clickWeek || 0"
              :readonly="!!!(offerCap.enabled)"
              @change="updateCap($event, `clickWeek`)"
              class="capInput"
              :class="disabledEnabledInput(!!(offerCap.enabled))"
              pattern="^\d+(?:\.\d{1,2})?$"
              onblur="this.parentNode.parentNode.style.backgroundColor=/^\d+(?:\.\d{1,2})?$/.test(this.value)?'inherit':'transparent'"
            />
          </div>
          <div class="cap-control">
            <label>Amount (Month)</label>
            <input
              type="number"
              step="1"
              placeholder="1000"
              min="1"
              max="99999"
              :value="offerCap && offerCap.clickMonth || 0"
              :readonly="!!!(offerCap.enabled)"
              @change="updateCap($event, `clickMonth`)"
              class="capInput"
              :class="disabledEnabledInput(!!(offerCap.enabled))"
              pattern="^\d+(?:\.\d{1,2})?$"
              onblur="this.parentNode.parentNode.style.backgroundColor=/^\d+(?:\.\d{1,2})?$/.test(this.value)?'inherit':'transparent'"
            />
          </div>
        </div>

        <!-- Redirect for Clicks -->
        <div class="redirect-section">
          <b-form-checkbox
            size="lg"
            type="checkbox"
            class="condition__matches campaign offerCapCheckbox"
            :checked="!!(offerCap.clicksRedirectOfferUseDefault === null ? 1 : offerCap.clicksRedirectOfferUseDefault)"
            @change="updateCap($event, `clicksRedirectOfferUseDefault`)"
            :disabled="!!!(offerCap.enabled)"
          >
            Use exit traffic redirect when capped
          </b-form-checkbox>
          <custom-select
            v-show="!!!(offerCap.clicksRedirectOfferUseDefault === null ? 1 : offerCap.clicksRedirectOfferUseDefault)"
            :options="getOffersList()"
            label="nameId"
            @search="exitTrafficOffersUpd"
            :filterable="false"
            :value="offerCap.clicksRedirectOfferId && offerCap.clickExitTrafficOfferName ? offerCap.clicksRedirectOfferId + ' ' + offerCap.clickExitTrafficOfferName : ''"
            class="custom_select"
            @input="updateCap($event, `clicksRedirectOfferId`)"
            :clearable="false"
          />
        </div>
      </div>

      <!-- Date Range -->
      <div class="cap-section">
        <div class="redirect-section">
          <b-form-checkbox
            size="lg"
            type="checkbox"
            class="condition__matches campaign offerCapCheckbox"
            :checked="!!(offerCap.useStartEndDate === null ? 1 : offerCap.useStartEndDate)"
            @change="updateCap($event, `useStartEndDate`)"
            :disabled="!!!(offerCap.enabled)"
          >
            Use date
          </b-form-checkbox>
          <div class="date-range">
            <v-menu
              v-model="starDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Start date"
                  readonly
                  :value="starDateDisplay"
                  :disabled="!!!(offerCap.useStartEndDate === null ? 1 : offerCap.useStartEndDate)"
                  v-on="on"
                  class="date-input"
                />
              </template>
              <v-date-picker
                locale="en-in"
                no-title
                :disabled="!!!(offerCap.enabled)"
                @input="updStartDate"
              />
            </v-menu>
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="End date"
                  readonly
                  :value="endDateDisplay"
                  :disabled="!!!(offerCap.useStartEndDate === null ? 1 : offerCap.useStartEndDate)"
                  v-on="on"
                  class="date-input"
                />
              </template>
              <v-date-picker
                locale="en-in"
                no-title
                :disabled="!!!(offerCap.enabled)"
                @input="updEndDate"
              />
            </v-menu>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-cancel" @click="close">
          Cancel
        </button>
        <button type="button" class="btn btn-save btn-primary" @click="saveLp()">
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {ModelSelect} from 'vue-search-select'
import {mapGetters, mapMutations} from 'vuex'
import {formatData} from '../../../../helpers'
import {debounce} from "debounce";
import store from "../../../../store";
import 'vue-select/dist/vue-select.css'

export default {
  data() {
    return {
      visible: false,
      editMode: false,
      segmentId: 0,
      weight: 0,
      lpId: 0,
      id: 0,
      checkedConversions: false,
      checkedClicks: false,
      starDateMenu: false,
      endDateMenu: false,
    }
  },
  props: ['offerId', 'offerCap', 'offers'],
  components: {ModelSelect},
  computed: {
    ...mapGetters('lp', ['getLandingPages']),
    ...mapGetters('countries', ['getCountries']),
    starDateDisplay() {
      return this.offerCap.startDate
    },
    endDateDisplay() {
      return this.offerCap.endDate
    },

  },
  created() {
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        this.visible = false
      }
    });
  },
  methods: {
    ...mapMutations('offer', [
      'changeGeo',
      'allowAll',
      'banAll',
      'updOfferCap',
      'preSaveCap',
      'cancelCap'
    ]),
    ...mapMutations('countries', ['filterCountry']),
    async exitTrafficOffersUpd(event) {
      this.debounceUpdateExitOffers(event)
    },
    debounceUpdateExitOffers: debounce(async (search) => {
      await store.dispatch('offer/saveExitTrafficOffersStore', {search})
    }, 700),
    allowAllEvent() {
      this.allowAll()
    },
    formatDate_(date) {
      return formatData(date)
    },
    getOffersList() {
      return this.offers
    },
    getClassDisabled(flag) {
      if (flag) {
        return 'disabled'
      }
    },
    updStartDate(date) {
      this.updateCap(date, 'startDate')
      this.starDateMenu = false
    },
    updEndDate(date) {
      this.updateCap(date, 'endDate')
      this.endDateMenu = false
    },
    disabledEnabledInput(enabled) {
      return enabled ? "enabledInput" : "disabledInput"
    },
    updateCap(event, field) {
      let obj = {}
      obj.fieldName = field
      if (field === `salesRedirectOfferId`
          || field === `clicksRedirectOfferId`
          || field === `startDate`
          || field === `endDate`
          || field === `clicksRedirectOfferUseDefault`
          || field === `salesRedirectOfferUseDefault`
          || field === `useStartEndDate`
          || field === `enabled`
      ) {
        if (field === 'clicksRedirectOfferUseDefault'
            || field === 'salesRedirectOfferUseDefault'
            || field === 'useStartEndDate'
            || field === `enabled`
        ) {
          obj.value = Number(event)
        } else {
          obj.value = event.id ? event.id : event
        }
      } else {
        obj.value = event.target.value
      }

      this.updOfferCap(obj)
      if (field === `salesRedirectOfferId`){
        obj.fieldName = 'saleExitTrafficOfferName'
        obj.value = event.name
        this.updOfferCap(obj)
      }
      if (field === `clicksRedirectOfferId`){
        obj.fieldName = 'clickExitTrafficOfferName'
        obj.value = event.name
        this.updOfferCap(obj)
      }
      const capValidationSales = this.capsClicksSalesValidation('sales')
      const capValidationClicks = this.capsClicksSalesValidation('clicks')
      if (!capValidationSales || !capValidationClicks) {
        const salesEl = document.querySelector(`.amounts-sales`);
        const clicksEl = document.querySelector(`.amounts-clicks`);

        if (salesEl) salesEl.style.background = 'white';
        if (clicksEl) clicksEl.style.background = 'white';
      }
    },
    capsClicksSalesValidation(type) {

      const capsValidations = this.offerCap
      const capValidationSales = Number(capsValidations.salesDay) === 0 && Number(capsValidations.salesWeek) === 0 && Number(capsValidations.salesMonth) === 0
      const capValidationClicks = Number(capsValidations.clickDay) === 0 && Number(capsValidations.clickWeek) === 0 && Number(capsValidations.clickMonth) === 0
      return type === 'clicks' ? capValidationClicks : capValidationSales
    },
    banAllEvent() {
      this.banAll(this.getCountries)
    },
    searchCountry(event) {
      let searchValue = event.target.value
      this.filterCountry(searchValue)
    },
    changeCountry(event, code) {
      console.log(event.target.checked)
      console.log(code)
      let obj = {}
      obj.countryCode = code
      obj.checked = event.target.checked
      this.changeGeo(obj)
    },
    getClassActiveOrNotCountry(code) {
      let include = true
      let exclude = false

      if (this.geoRules) {
        let rules = JSON.parse(this.geoRules)
        let match = rules.geo.filter(item => {
          return item.country === code
        })
        if (match.length !== 0) {
          if (match[0].include === true) {
            return include
          } else {
            return exclude
          }

        } else {
          return exclude
        }
      }

      return exclude

    },
    defineId(name, id) {
      this.disableAutocomplete(`${name}-${id}`)
      return `${name}-${id}`
    },
    disableAutocomplete(id) {
      let addAtr = document.getElementById(id);
      if (addAtr) {
        addAtr.setAttribute('autocomplete', 'disable');
      }
    },
    show(id) {
      this.visible = true
    },
    saveLp(data) {

      const capValidationSales = this.capsClicksSalesValidation('sales')
      const capValidationClicks = this.capsClicksSalesValidation('clicks')
      if (capValidationSales && capValidationClicks && this.offerCap.enabled) {
        document.querySelector(`.amounts-sales`).style.background = 'red'
        document.querySelector(`.amounts-clicks`).style.background = 'red'
      } else {
        this.visible = false
        this.preSaveCap()
        let confirmCreateCampaigns = this.$dialog.info({
          text: `Cap settings saved`,
          title: 'cap'
        })


      }

    },
    close() {
      this.visible = false
      this.cancelCap()
    },

  }
}
</script>

<style lang="sass">
.caps-modal
  // Modal container styles
  width: 90vw
  max-width: 600px
  max-height: 90vh
  padding: 20px
  background: #fff
  border-radius: 8px
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33)
  overflow-y: auto
  overflow-x: hidden

  // Modal title
  .modal-title
    font-size: 28px
    font-weight: 700
    margin-bottom: 20px
    text-align: left
    color: #2b3e48

  // Cap section
  .cap-section
    margin-bottom: 15px

  // Section title
  .section-title
    font-size: 16px
    font-weight: 600
    margin-bottom: 8px
    border-bottom: 1px solid #e3eef4
    padding-bottom: 4px

  // Cap row
  .cap-row
    display: flex
    justify-content: space-between
    gap: 8px

  // Cap control
  .cap-control
    flex: 1
    display: flex
    flex-direction: column
    gap: 4px

    label
      font-size: 13px
      color: #2b3e48

  // Cap input
  .capInput
    width: 100%
    height: 34px
    padding: 6px
    font-size: 13px
    color: #7F98A5
    background: #fff
    border: 1px solid #d1dbe0
    border-radius: 4px
    box-sizing: border-box

  .enabledInput
    background: #fff

  .disabledInput
    background: #f1f3f5

  // Redirect section
  .redirect-section
    display: flex
    flex-direction: column
    gap: 8px
    margin-top: 8px

    .custom_select
      width: 100%
      max-width: 300px

  // Date range
  .date-range
    display: flex
    gap: 8px

    .date-input
      flex: 1
      max-width: 200px

      input
        height: 34px
        font-size: 13px
        padding: 6px
        border: 1px solid #d1dbe0
        border-radius: 4px

  // Status label
  .status-label
    font-size: 13px
    color: #2b3e48
    margin-left: 8px

  // Modal footer
  .modal-footer
    display: flex
    justify-content: space-between
    align-items: center
    padding: 20px 0
    margin-top: 20px

  // Button styles (scoped to caps-modal)
  .btn
    padding: 8px 24px
    font-size: 14px
    font-weight: 500
    border-radius: 4px
    border: none
    cursor: pointer
    text-transform: uppercase
    transition: all 0.3s ease
    min-width: 140px

  .btn-cancel
    background: #d1dbe0
    color: #2b3e48

    &:hover
      background: #c1ccd1
      transform: translateY(-1px)

    &:active
      transform: translateY(0)

  .btn-save
    background: #40c4ff
    color: #fff

    &:hover
      background: #29b6f6
      transform: translateY(-1px)

    &:active
      transform: translateY(0)

  // Checkbox condition
  .condition__matches
    font-size: 13px

// Modal mask (outside caps-modal, as it applies to the full screen)
.modal-mask
  position: fixed
  z-index: 9998
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  background-color: rgba(0, 0, 0, 0.7)
  display: flex
  align-items: center
  justify-content: center
</style>
